import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Suggest from './views/Suggest.vue';
import Report from './views/Report.vue';
import CustomQuiz from './views/CustomQuiz';
import TradycyjniEuropejczycy from '@/views/results/TradycyjniEuropejczycy';
import KanapowiBuntownicy from '@/views/results/KanapowiBuntownicy';
import NormHolderzy from '@/views/results/NormHolderzy';
import WierniOjczyznie from '@/views/results/WierniOjczyznie';
import DizajnerzyZycia from '@/views/results/DizajnerzyZycia';
import WypedzaniZRaju from '@/views/results/WypedzaniZRaju';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/suggest',
      name: 'suggest',
      component: Suggest,
    },
    {
      path: '/report/:id',
      name: 'report',
      component: Report,
    },
    {
      path: '/customize',
      name: 'customize',
      component: CustomQuiz,
    },
    {
      path: '/wynik/dizajnerzy-zycia',
      name: 'dizajnerzyzycia',
      component: DizajnerzyZycia,
    },
    {
      path: '/wynik/kanapowi-buntownicy',
      name: 'kanapowibuntownicy',
      component: KanapowiBuntownicy,
    },
    {
      path: '/wynik/norm-holderzy',
      name: 'normholderzy',
      component: NormHolderzy,
    },
    {
      path: '/wynik/tradycyjni-europejczycy',
      name: 'tradycyjnieuropejczycy',
      component: TradycyjniEuropejczycy,
    },
    {
      path: '/wynik/wierni-ojczyznie',
      name: 'wierniojczyznie',
      component: WierniOjczyznie,
    },
    {
      path: '/wynik/wypedzani-z-raju',
      name: 'wypedzanizraju',
      component: WypedzaniZRaju,
    },
  ],
});
